import { Caption, H4 } from '@liveauctioneers/hammer-ui-core/text';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import { featuredCategoriesSelector } from '@/redux/modules/featuredCategories';
import { FeaturedCategory } from '@/types/FeaturedCategory';
import { addImageParams } from '@/utils/urls';

const imageWidth = 165;
const imageHeight = 110;

export const HeroBannerFeaturedCardList = () => {
    const categories = useAppSelector(featuredCategoriesSelector);
    const categoriesToShow = categories.slice(0, 4);

    const featuredCards = categoriesToShow.map(({ imageUrl, label, link, title }: FeaturedCategory, index: number) => {
        const src = addImageParams({
            height: imageHeight,
            url: imageUrl,
            width: imageWidth,
        });
        const highDpiSrc = addImageParams({
            height: imageHeight * 2,
            url: imageUrl,
            width: imageWidth * 2,
        });

        return (
            <RouteLink
                className="h-full w-full no-underline smMax:last:hidden"
                key={`${title}-${index}`}
                to={link}
            >
                <div
                    className="flex flex-col text-center"
                    data-testid="categoryCard"
                >
                    <img
                        alt={title}
                        className="mx-auto"
                        height={imageHeight}
                        src={src}
                        srcSet={`${highDpiSrc} 2x`}
                        width={imageWidth}
                    />
                    <H4 data-testid="categoryTitle">{title}</H4>
                    <Caption color="secondary">{label}</Caption>
                </div>
            </RouteLink>
        );
    });

    return <div className="my-auto flex">{featuredCards}</div>;
};
